<app-admin-page-section titleT="admin.batch-creation.customer-spaces">
    <div class="admin-action-item-list">
        <app-admin-action-item titleT="admin.batch-creation.upload-file">
            <app-button-indicator-upload [isPending]="false" (clicked)="openFileUploadDialog()" />
        </app-admin-action-item>
    </div>
</app-admin-page-section>
